window.$ = window.jQuery = require('jquery');

import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {ScrollToPlugin} from 'gsap/ScrollToPlugin'
import lottie from 'lottie-web';

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

window.gsap           = gsap;
window.ScrollTrigger  = ScrollTrigger;
window.ScrollToPlugin = ScrollToPlugin;

const sou0 = 'ridea/npm/js/frontend/pages/json/sou0.json';
const sou1 = 'ridea/npm/js/frontend/pages/json/sou1.json';
const sou2 = 'ridea/npm/js/frontend/pages/json/sou2.json';
const sou3 = 'ridea/npm/js/frontend/pages/json/sou3.json';
const sou4 = 'ridea/npm/js/frontend/pages/json/sou4.json';
const sou5 = 'ridea/npm/js/frontend/pages/json/sou5.json';
document.addEventListener('DOMContentLoaded', () => {

    getReCaptchaPrice();
    observeFormAjax('#price-contact-form','#price_contact_submit_button', {
        ignore : [] ,
        rules: {
            name: { required: true },
            sex: { required: true },
            email: { required: true, email: true },
            tel: { required: true },
            content: { required: true },
            company: { required: true},
            budget: { required: true },
            "contact_projects[]": "required",
        },
        messages: {
            company: "請輸入公司名稱",
            name: "請輸入姓名",
            email: {
                required: '請輸入電子郵件',
                email: '請輸入正確 Email 格式',
            },
            tel: "請輸入聯絡電話",
            budget: "請輸入專案預算",
            content: "請輸入諮詢內容",
            "contact_projects[]": "請選擇專案類型",
        }
    }, null, 'price-contact-form');


    $('.rd_clear').on('click', function(){
        var form = document.getElementById("top-contact-form");
        form.reset();
    });


    $('.rd_price_sex').on('click', function () {
        $('.rd_price_sex').removeClass('now');
        $(this).addClass('now');
        $("[name='sex']").val($(this).attr('data-sex'));
    });

    $('.rd-price-contact-project').on('click', function(){
        if($(this).hasClass('now')){
            $('#input_price_contact_project_' + $(this).data('id')).remove();
            $(this).removeClass('now');
        }else{
            $('#rd-price-contact-project-area').append('<input type="hidden" class="rd-price-mutliple-contact-projects rd-price-contact-project-selected" name="contact_projects[]" id="input_price_contact_project_'+ $(this).data('id') +'" value="'+ $(this).data('id') +'">');
            $(this).addClass('now');
        }

        if ($(".rd-price-mutliple-contact-projects")[1]){
            $('#main_price_contact_project_input').val('pass');
        } else {
            $('#main_price_contact_project_input').val('');
        }

        var allEmpty = true;

        $('.rd-price-contact-project-selected').each(function(){
            if ($(this).val().trim() !== "") {
                allEmpty = false;
                return false;
            }
        });

        let target  = $(this).closest('.rd_show_validator_error');

        if (allEmpty) {
            $(target).append('<div class="rd_notice" style="width: 100%;margin-top: .25rem;font-size: 80%;color: #dc3545;">請選擇專案類型</div>');
            $(this).closest('.rd_required').find('.selectric').css("border-bottom", "1px solid #dc3545");
        } else {
            $(this).closest('.rd_required').find('.rd_notice').remove();
            $(this).closest('.rd_required').find('.selectric').css("border-bottom", "1px solid #ddd");
        }
    });

    const asou0 = lottie.loadAnimation({
        container: document.getElementById('pcin-svg'), // **DOM 容器**
        renderer: 'svg', // 渲染模式：'svg' (推薦) 或 'canvas'
        loop: true, // 是否循環播放
        autoplay: true, // 是否自動播放
        path: sou0 // **JSON 檔案路徑**
    });

    const asou1 = lottie.loadAnimation({
        container: document.getElementById('ai-svg'), // **DOM 容器**
        renderer: 'svg', // 渲染模式：'svg' (推薦) 或 'canvas'
        loop: true, // 是否循環播放
        autoplay: true, // 是否自動播放
        path: sou1 // **JSON 檔案路徑**
    });
    const asou2 = lottie.loadAnimation({
        container: document.getElementById('line-svg'), // **DOM 容器**
        renderer: 'svg', // 渲染模式：'svg' (推薦) 或 'canvas'
        loop: true, // 是否循環播放
        autoplay: true, // 是否自動播放
        path: sou2 // **JSON 檔案路徑**
    });
    const asou3 = lottie.loadAnimation({
        container: document.getElementById('seo-svg'), // **DOM 容器**
        renderer: 'svg', // 渲染模式：'svg' (推薦) 或 'canvas'
        loop: true, // 是否循環播放
        autoplay: true, // 是否自動播放
        path: sou3 // **JSON 檔案路徑**
    });
    const asou4 = lottie.loadAnimation({
        container: document.getElementById('esg-svg'), // **DOM 容器**
        renderer: 'svg', // 渲染模式：'svg' (推薦) 或 'canvas'
        loop: true, // 是否循環播放
        autoplay: true, // 是否自動播放
        path: sou4 // **JSON 檔案路徑**
    });
    const asou5 = lottie.loadAnimation({
        container: document.getElementById('partner-svg'), // **DOM 容器**
        renderer: 'svg', // 渲染模式：'svg' (推薦) 或 'canvas'
        loop: true, // 是否循環播放
        autoplay: true, // 是否自動播放
        path: sou5 // **JSON 檔案路徑**
    });


});

let solution1 = gsap.timeline();
ScrollTrigger.create({
    animation: solution1,
    trigger: ".soultions-s1-kv",
    start: "100 top",
    end: "500 top",
    scrub: 2,
    // markers:true
});
solution1.fromTo(".cirred", {top:'0'},{top:'90%'}, 0)

let solution2 = gsap.timeline();
ScrollTrigger.create({
    animation: solution2,
    trigger: ".soultions-s2-start",
    start: "top-=300 top",
    end: "top+=100 top",
    scrub: 2,
    // markers:true
});
solution2.fromTo(".cir-right", {marginRight:'-700px',rotate:'0deg'},{marginRight:'-100px',rotate:'-30deg'}, 0)
solution2.fromTo(".cir-left", {marginLeft:'-700px',rotate:'0deg'},{marginLeft:'-100px',rotate:'30deg'}, 0)
solution2.fromTo(".pcin-svg", {opacity:'0',y:30},{opacity:'1',y:0,duration: 0.3}, '-=0.3')

let s2scroline = gsap.timeline();
ScrollTrigger.create({
    animation: s2scroline,
    trigger: ".soultions-s2-start",
    start: "top+=100 top",
    end: "top+=300 top",
    scrub: 2,
    // markers:true
});
s2scroline.fromTo(".soultions-s2-start .linered", {y:0},{y:70}, 0)


ScrollTrigger.create({
    trigger: ".soultions-s2-start",
    start: "top-=500 top",
    // markers:true,
    onEnter:function () {
        $('.soultions-s2-start').addClass('vivi')
    }
});
ScrollTrigger.create({
    trigger: ".soultions-part1",
    start: "top-=400 top",
    // markers:true,
    onEnter:function () {
        $('.soultions-part1').addClass('vivi')
    }
});
let s3scroline = gsap.timeline();
ScrollTrigger.create({
    animation: s3scroline,
    trigger: ".soultions-part1",
    start: "top+=0 top",
    end: "top+=200 top",
    scrub: 2,
    // markers:true
});
s3scroline.fromTo(".soultions-part1 .linered", {y:0},{y:70}, 0)

ScrollTrigger.create({
    trigger: ".soultions-part2",
    start: "top-=400 top",
    // markers:true,
    onEnter:function () {
        $('.soultions-part2').addClass('vivi')
    }
});

let s4scroline = gsap.timeline();
ScrollTrigger.create({
    animation: s4scroline,
    trigger: ".soultions-part2",
    start: "bottom-=300 top",
    end: "bottom-=200 top",
    scrub: 2,
    // markers:true
});
s4scroline.fromTo(".soultions-part2 .linered", {y:0},{y:70}, 0)

ScrollTrigger.create({
    trigger: ".soultions-part3",
    start: "top-=400 top",
    // markers:true,
    onEnter:function () {
        $('.soultions-part3').addClass('vivi')
    }
});
let s5scroline = gsap.timeline();
ScrollTrigger.create({
    animation: s5scroline,
    trigger: ".soultions-part3",
    start: "bottom-=300 top",
    end: "bottom-=200 top",
    scrub: 2,
    // markers:true
});
s5scroline.fromTo(".soultions-part3 .linered", {y:0},{y:70}, 0)

ScrollTrigger.create({
    trigger: ".soultions-part4",
    start: "top-=400 top",
    // markers:true,
    onEnter:function () {
        $('.soultions-part4').addClass('vivi')
    }
});
let s6scroline = gsap.timeline();
ScrollTrigger.create({
    animation: s6scroline,
    trigger: ".soultions-part4",
    start: "bottom-=300 top",
    end: "bottom-=200 top",
    scrub: 2,
    // markers:true
});
s6scroline.fromTo(".soultions-part4 .linered", {y:0},{y:70}, 0)

ScrollTrigger.create({
    trigger: ".soultions-part5",
    start: "top-=400 top",
    // markers:true,
    onEnter:function () {
        $('.soultions-part5').addClass('vivi')
    }
});
let s7scroline = gsap.timeline();
ScrollTrigger.create({
    animation: s7scroline,
    trigger: ".soultions-part5",
    start: "bottom-=300 top",
    end: "bottom-=200 top",
    scrub: 2,
    // markers:true
});
s7scroline.fromTo(".soultions-part5 .linered", {y:0},{y:70}, 0)

ScrollTrigger.create({
    trigger: ".soultions-part6",
    start: "top-=400 top",
    // markers:true,
    onEnter:function () {
        $('.soultions-part6').addClass('vivi')
    }
});
let s8scroline = gsap.timeline();
ScrollTrigger.create({
    animation: s8scroline,
    trigger: ".soultions-part6",
    start: "bottom-=300 top",
    end: "bottom-=200 top",
    scrub: 2,
    // markers:true
});
s8scroline.fromTo(".soultions-part6 .linered", {y:0},{y:70}, 0)


// 建立 matchMedia 物件
let mm = gsap.matchMedia();

// 定義變數 (放在外面方便管理)
const moveDuration = 1.0;
const holdDuration = 1.5;

// ✨ 關鍵：使用 mm.add 設定媒體查詢條件
// "(min-width: 1000px)" 代表寬度大於等於 1000px 時才執行
mm.add("(min-width: 1000px)", () => {

    // ======================= 動畫 1 / solution3 (向左移) =======================
    let solution3 = gsap.timeline({
        defaults: { duration: moveDuration, overwrite: 'auto' }
    });

    ScrollTrigger.create({
        animation: solution3,
        trigger: ".soultions-part1",
        start: "top center",
        end: "bottom top",
        scrub: 2,
        // markers: true
    });

    solution3.to(".ripple-container", {scale: 0.8, x: -400}, 0);
    solution3.to(".ripple-container", {duration: holdDuration}, ">");
    solution3.to(".ripple-container", {scale: 1, x: 0}, ">");


    // ======================= 動畫 2 / solution4 (向右移) =======================
    let solution4 = gsap.timeline({
        defaults: { duration: moveDuration, overwrite: 'auto' }
    });

    ScrollTrigger.create({
        animation: solution4,
        trigger: ".soultions-part3",
        start: "top center",
        end: "bottom top",
        scrub: 2,
        // markers: true
    });

    solution4.to(".ripple-container", {scale: 0.8, x: 400}, 0);
    solution4.to(".ripple-container", {duration: holdDuration}, ">");
    solution4.to(".ripple-container", {scale: 1, x: 0}, ">");


    // ======================= 動畫 3 / solution5 (向左移) =======================
    let solution5 = gsap.timeline({
        defaults: { duration: moveDuration, overwrite: 'auto' }
    });

    ScrollTrigger.create({
        animation: solution5,
        trigger: ".soultions-part5",
        start: "top center",
        end: "bottom top",
        scrub: 2,
        // markers: true
    });

    solution5.to(".ripple-container", {scale: 0.8, x: -400}, 0);
    solution5.to(".ripple-container", {duration: holdDuration}, ">");
    solution5.to(".ripple-container", {scale: 1, x: 0}, ">");

    // return () => {
    //   // 這裡通常不需要寫東西，因為 GSAP 會自動清理
    //   // 除非你有建立非 GSAP 的事件監聽器才需要手動清理
    // };
});


